module.exports = __webpack_public_path__ + "img/collapsed.7bd4c90f.png";